import type { ThemeOptions } from '@mui/material/styles';

import { FONT_FAMILY, FONT_SIZE_BASE, FONT_SIZES } from './tokens';

// Só `fontSize` por variante: o merge por variante do `createTypography` preserva
// `fontWeight`, `lineHeight` e `textTransform` que o MUI já monta (h1 em peso 300,
// button/overline em uppercase, etc.).
export const typography: ThemeOptions['typography'] = {
  fontFamily: FONT_FAMILY,
  fontSize: FONT_SIZE_BASE,
  h1: { fontSize: FONT_SIZES.h1 },
  h2: { fontSize: FONT_SIZES.h2 },
  h3: { fontSize: FONT_SIZES.h3 },
  h4: { fontSize: FONT_SIZES.h4 },
  h5: { fontSize: FONT_SIZES.h5 },
  h6: { fontSize: FONT_SIZES.h6 },
  subtitle1: { fontSize: FONT_SIZES.subtitle1 },
  subtitle2: { fontSize: FONT_SIZES.subtitle2 },
  body1: { fontSize: FONT_SIZES.body1 },
  body2: { fontSize: FONT_SIZES.body2 },
  button: { fontSize: FONT_SIZES.button },
  caption: { fontSize: FONT_SIZES.caption },
  overline: { fontSize: FONT_SIZES.overline },
};
